import {
  CHATBOT_HOST_EU,
  CHATBOT_HOST_US,
  HOST_EU,
  HOST_US
} from 'constants/endpoints';
import { Region } from 'constants/enums';

export const HOST_BY_REGION: Record<Region, string> = {
  [Region.US]: HOST_US,
  [Region.EU]: HOST_EU
};

export const getHostForRegion = (region: Region | null | undefined): string => {
  if (!region) {
    throw new Error('Region is not defined for main API host resolution');
  }
  const host = HOST_BY_REGION[region];
  if (!host) {
    throw new Error(`Host is not configured for region: ${region}`);
  }
  return host;
};

const CHATBOT_HOST_BY_REGION: Record<Region, string> = {
  [Region.US]: CHATBOT_HOST_US,
  [Region.EU]: CHATBOT_HOST_EU
};

export const getChatbotHostForRegion = (
  region: Region | null | undefined
): string => {
  if (!region) {
    throw new Error('Region is not defined for chatbot API host resolution');
  }
  const host = CHATBOT_HOST_BY_REGION[region];
  if (!host) {
    throw new Error(`Chatbot host is not configured for region: ${region}`);
  }
  return host;
};
